// Bridge to the DesiCaptions desktop app (Electron shell in /desktop).
//
// The shell exposes `window.desicaptionsDesktop` from its preload script. Its
// presence is the only thing the web app branches on, so a browser build is
// unaffected. Keep every call optional: the site must work when the bridge is
// missing, and a shell older than this build may lack a newer method.

export const isDesktop = () => typeof window !== 'undefined' && Boolean(window.desicaptionsDesktop);

export const desktopVersion = () => window.desicaptionsDesktop?.version || null;

// Open a URL in the user's real browser. Falls back to a new tab in the browser.
export async function openExternal(url) {
  if (window.desicaptionsDesktop?.openExternal) {
    const ok = await window.desicaptionsDesktop.openExternal(url);
    if (ok) return true;
  }
  window.open(url, '_blank', 'noopener');
  return false;
}

// Subscribe to the `desicaptions://` deep link the browser sends back after a
// sign-in approval. Returns an unsubscribe function.
export function onDesktopCallback(callback) {
  const bridge = window.desicaptionsDesktop;
  if (!bridge?.onAuthCallback) return () => {};
  return bridge.onAuthCallback(callback);
}

// Custom scheme the desktop app registers with the OS. Must match
// desktop/electron/main.js and the `protocols` block in electron-builder.yml.
export const DESKTOP_SCHEME = 'desicaptions';
